import type { z as Z } from 'zod';

import { z } from 'zod';

/**
 * A day-in-the-life keeps its own branch-and-merge shape, so its inner document is open;
 * its activities are still judged node by node like every other template's.
 */
export const Dil = z.looseObject({});
export type Dil = Z.infer<typeof Dil>;
